import { post, get, patch, deleteRequest } from './restApi';
import * as restGateway from './restGatewayApi'
export const getListSensors = (payload) => {
    return get('sensor/get-list', { ...payload });
}
export const createSensor = async (payload) => {
    const res = await restGateway.post('sensor/create', payload);
    if (res && res.code === 1) {
        return post('sensor/create', { ...res.data });
    }
    return;
}
export const updateSensor = async (sensorId, payload) => {
    const res = await restGateway.patch('sensor/update/' + sensorId, payload);
    if (res && res.code === 1) {
        return patch(`sensor/update/` + sensorId, { ...res.data });
    }
    return;
}

export const deleteSensor = async (sensorId, payload) => {
    const res = await restGateway.deleteRequest(`sensor/delete/` + sensorId, { ...payload });
    if (res && res.code === 1) {
        return deleteRequest(`sensor/delete/` + sensorId, { ...payload });
    }
    return;
}
export const getSensorById = (sensorId, payload) => {
    return get(`sensor/get-by-id/` + sensorId, { ...payload });
}
export const getListAssetMaintenanceMappingSensor = (sensorId, payload) => {
    return get('sensor/get-asset-maintenance-mapping/' + sensorId, { ...payload });
}
export const createAssetMaintenanceMappingSensor = (sensorId, payload) => {
    return post('sensor/create-asset-maintenance-mapping/' + sensorId, payload);
}
export const deleteAssetMaintenanceMappingSensor = (id, payload) => {
    return deleteRequest('sensor/delete-asset-maintenance-mapping/' + id, { ...payload });
}
export const getAssetMaintenanceNotMapiingSensor = (sensorId, payload) => {
    return get('sensor/get-asset-maintenance-not-mapping/' + sensorId, { ...payload });
}
export const getRealtimeSensorData = (payload) => {
    return get('sensor/realtime-sensor-data', { ...payload });
}